module.exports = __webpack_public_path__ + "static/media/image-general-fitness@2x.45c3b874.png";